// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-time-input {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 3.75rem auto 3.75rem;
    gap: 4px;
    align-items: center;
    width: 100%;
    min-width: 0;
}

.date-time-input > .date-time-input__part.date-time-input__part {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-height: 44px;
    height: 100%;
    padding: 0 6px;
    font: inherit;
}

.date-time-input__separator {
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/web/component/DateTimeInput/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0DAA0D;IAC1D,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".date-time-input {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 3.75rem auto 3.75rem;\n    gap: 4px;\n    align-items: center;\n    width: 100%;\n    min-width: 0;\n}\n\n.date-time-input > .date-time-input__part.date-time-input__part {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    min-height: 44px;\n    height: 100%;\n    padding: 0 6px;\n    font: inherit;\n}\n\n.date-time-input__separator {\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
